import "./client-slider.component.css"
import Marquee from "react-fast-marquee"
import useCheckForMobileHook from "../../hooks/useCheckForMobileHook"
import StrapiImageComponent from "../strapi-image/strapi-image.component"

const ClientSliderComponent = (props) => {
  const { Heading, Background, Items, UseText, Text } = props
  const isMobile = useCheckForMobileHook()

  const createClientItem = (item) => {
    let padding = 0
    if (item.PaddingPercentage) {
      const amt = isMobile
        ? item.PaddingPercentage * 0.2
        : item.PaddingPercentage
      padding = `${amt}%`
    }

    return (
      <div key={item.id} className="dagger-client-item">
        <StrapiImageComponent
          style={{ padding }}
          attributes={item.Media?.data?.attributes}
          sizes="(max-width: 600px) 25vw, 10vw"
        />
      </div>
    )
  }

  const containerClass =
    Background && Background === "White"
      ? "dagger-client-slider bg-white"
      : "dagger-client-slider"

  return (
    <div className={containerClass}>
      {Heading && <h6>{Heading}</h6>}
      <Marquee className="dagger-client-items" speed={isMobile ? 37.5 : 25}>
        {!UseText && Items && Items?.filter(Boolean).map((i) => createClientItem(i))}
        {UseText &&
          Text &&
          Array.from({ length: 10 }, (_, index) => <h5 key={index}>{Text}</h5>)}
      </Marquee>
    </div>
  )
}

export default ClientSliderComponent
